'use strict';

var Params = function Params(containerWidth, containerHeight) {
  var padding = {
    top: 5,
    bottom: 30,
    left: 0,
    right: 20
  };
  var width = containerWidth - (padding.left + padding.right);
  var height = containerHeight - (padding.top + padding.bottom);
  return {
    width: width,
    height: height,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    padding: padding,
    yNumberOfTicks: 5,
    yAxisShift: 12,
    yAxisLabelShift: 55
  };
};
module.exports = Params;